

// icons
import { close } from 'ionicons/icons';

// components
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
        IonGrid, IonRow, IonButtons, IonButton, IonIcon, IonBackButton,
        IonItem, IonLabel, IonList, IonListHeader,
        IonInput, IonTextarea,
        loadingController, toastController } from '@ionic/vue';

import { computed, ref } from 'vue';

// services
import CommonService from '@/services/CommonService';

import { useI18n } from 'vue-i18n';
import { useStore } from '@/store';
import { useRoute } from 'vue-router';

export default {
  name: 'FeedbackPage',
  components: { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
                IonGrid, IonRow, IonButtons, IonButton, IonIcon, IonBackButton,
                IonItem, IonLabel, IonList, IonListHeader,
                IonInput, IonTextarea, },
  setup() {
    // state variables
    const store = useStore();

    const user = computed(() => store.state.user);
    const name = ref(user.value.fullName || "");
    const email = ref(user.value.email || "");
    const feedback = ref("");
    const photo = ref<any>("");
    const photoFile = ref<any>(null);

    const route = useRoute();

    // methods
    const { t } = useI18n();
    const submitFeedback = async () => {
      const loading = await loadingController.create({});
      await loading.present();
      const res = await CommonService.createNewFeedback(name.value, email.value, feedback.value, photoFile.value);
      loading.dismiss();
      feedback.value = "";
      const toast = await toastController.create({
        message: t('FeedbackPage.feedbackSubmitted'),
        duration: 5000,
        position: 'top',
      });
      toast.present();
    }

    const onImageFileChange = (e: any) => {
      if (e.target.files && e.target.files[0]) {
        photoFile.value = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          photo.value = e.target.result;
        }
        reader.readAsDataURL(photoFile.value); // convert to base64 string and preview it
        e.srcElement.value = null;
      }
    }
    const clearUploadedImage = () => {
      photo.value = "";
      photoFile.value = null;
    }
    
    return {
      // icons
      close,
      
      // variables
      name, email, feedback, photo, photoFile,

      // methods
      t, submitFeedback, onImageFileChange, clearUploadedImage,
    }
  },
}
